import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { updateCmsContentVariables, adminCmsAll } from '@api/graphql/types';
import { ApplicationState } from 'reducers/';
import { connect } from 'react-redux';
import CmsForm from '../components/CmsForm';

type Props = {
    cmsId: string,
} & InjectedIntlProps & RouteComponentProps<{cmsId: string}>;


interface State {
    formData: updateCmsContentVariables;
}

class CmsEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                id: this.props.cmsId,
                title: '',
                content: null,
                is_active: true,
                active_from: null,
                active_to: null,
                url_key: '',
                meta_title: null,
                meta_keywords: null,
                meta_description: null,
            },
        };
    }

    public componentDidMount() {
        GraphQLClient.query<adminCmsAll>({
            query: Queries.adminCmsAllContent,
            variables: {filters: {id: this.props.cmsId}, count: 1},
        }).then((response) => {
            if (response.data && response.data.adminCmsContents && response.data.adminCmsContents.data && response.data.adminCmsContents.data[0]) {
                this.setState({formData: response.data.adminCmsContents.data[0]});
            }
        });
    }

    public onSubmit = (formData: updateCmsContentVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateCmsContent, variables: formData,
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.cms.edit.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            {this.state.formData &&
                                <CmsForm formData={this.state.formData} onSubmit={this.onSubmit} redirectFunction={() => undefined}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { cmsId } = props.match.params;
    return { cmsId };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(CmsEdit);



// WEBPACK FOOTER //
// ./src/modules/Cms/pages/CmsEdit.tsx